import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-producto-carga-masiva',
  templateUrl: './producto-carga-masiva.component.html',
  styleUrls: ['./producto-carga-masiva.component.scss']
})
export class ProductoCargaMasivaComponent implements OnInit {
  urlTemplate: string = '../../../assets/template/siniestros.xlsx';
  acciones = ['Concatenar']
  urlApi = 'catalogo/PostINSproducto';
  fuente = 'productos'
  urlApiCatalogo = 'catalogo/GetCatalogosCargaMasiva';

  columnas = [
    {
      nombre: "nombreInterno",
      tipo: "string",
      longitud: 100,
      obligatorio: true
    },
    {
      nombre: "noIdentificacion",
      tipo: "string",
      longitud: 200,
      obligatorio: false
    },
    {
      nombre: "precioUnitario",
      tipo: "number",
      longitud: 50,
      obligatorio: true
    },
    {
      nombre: "descripcion",
      tipo: "string",
      longitud: 200,
      obligatorio: true
    },
    {
      nombre: "iva",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },

    {
      nombre: "ivaRet",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },
    {
      nombre: "IEPSTasa",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },
    {
      nombre: "IEPSCuota",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },
    {
      nombre: "IEPSTasaCat",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },
    // {
    //   nombre: "IEPSCuotaCuot",
    //   tipo: "number",
    //   longitud: 50,
    //   obligatorio: false
    // },
    {
      nombre: "ISR",
      tipo: "number",
      longitud: 50,
      obligatorio: false
    },
    {
      nombre: "claveProdServ",
      tipo: "number",
      longitud: 50,
      obligatorio: true
    },
    {
      nombre: "claveUnidadMedida",
      tipo: "number",
      longitud: 250,
      obligatorio: true
    },
    {
      nombre: "ObjetoImpuesto",
      tipo: "string",
      longitud: 5,
      obligatorio: true
    },
    
  ]

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  response(resp: any) {
    this.router.navigate(['/catalogos/productos']);
  }


}
